import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class OrderItem  {
    _originalTypeClassName = "ekylikeio.BO.OrderItem";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
OrderItem.translate = translateService;
}
this.Id = null;
this.Quantity = 1;
this.TotalPrice = null;
this.Status = null;
this.Notes = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Quantity:any;
TotalPrice:any;
Status:any;
Notes:any;
MenuItem:any;
PickupAt:any;
OrderSection:any;
static setMenuItem = ($this, value) => {
var oldValue = $this.MenuItem;
$this.MenuItem = value;
if (value != null) {
if (oldValue != null) {
Domain.MenuItem.removemenuItemToOrderItem(oldValue, $this);
}
Domain.MenuItem.addmenuItemToOrderItem(value, $this);
}
}
static setPickupAt = ($this, value) => {
var oldValue = $this.PickupAt;
$this.PickupAt = value;
if (value != null) {
}
}
static setOrderSection = ($this, value) => {
var oldValue = $this.OrderSection;
$this.OrderSection = value;
if (value != null) {
if (oldValue != null) {
Domain.OrderSection.removeItems(oldValue, $this);
}
Domain.OrderSection.addItems(value, $this);
}
}

static UpdatePrice($this: any): any{$this.TotalPrice = Joove.Common.safeNumber($this?.Quantity) * Joove.Common.safeNumber($this?.MenuItem?.Price);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}